import { Component } from '@angular/core';

@Component({
  selector: ' ez-banner',
  imports: [],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {}
